import {indexationStore} from '@store/settings/indexation/indexation.store';
import {getIndexationDataSource} from '@store/settings/indexation/indexation.requests';
import {getEntity} from '@ngneat/elf-entities';

export class IndexationQuery {
  store = indexationStore;

  indexations$ = getIndexationDataSource.data$();

  indexationById = (indexationId: number) => this.store.query(getEntity(indexationId));
}

export const indexationQuery = new IndexationQuery();
